import LocalizedStrings from 'localized-strings';

import { ReferralDisplayedStatus } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    description: 'Follow the progress of your referrals.',
    empty: 'No referral for the moment.\nInvite your contacts!',
    finishedReferrals: 'Finished referrals',
    finishedReferralsDescription:
      'Your contacts who have accepted your invitation',
    items: {
      labels: {
        [ReferralDisplayedStatus.NoTransaction]: 'Account opened',
        [ReferralDisplayedStatus.AccountOpened]: 'Account opened',
        [ReferralDisplayedStatus.UserCreated]: 'Pending',
        [ReferralDisplayedStatus.Sleeping]: 'Registration abandoned',
        [ReferralDisplayedStatus.ReferrerRewarded]: 'Validated',
        [ReferralDisplayedStatus.MaxReferrerRewardsReached]: 'Validated',
      },
    },
    onYear: 'In {0}',
    pendingReferrals: 'Pending referrals',
    promotionalOffer: 'Promotional offer',
    received: '{0} Received',
    referredOn: 'Referred on {0}',
    registeredOn: 'Registered on {0}',
    shouldMakeATransaction: 'Should make a transaction',
    title: 'Referrals',
  },
  fr: {
    description: 'Suivez la progression de vos parrainages.',
    empty: 'Aucun parrainage pour le moment.\nInvitez vos contacts !',
    finishedReferrals: 'Parrainages terminés',
    finishedReferralsDescription:
      'Vos contacts qui ont accepté votre invitation',
    items: {
      labels: {
        [ReferralDisplayedStatus.NoTransaction]: 'Compte ouvert',
        [ReferralDisplayedStatus.AccountOpened]: 'Compte ouvert',
        [ReferralDisplayedStatus.UserCreated]: 'En attente',
        [ReferralDisplayedStatus.Sleeping]: 'Inscription abandonnée',
        [ReferralDisplayedStatus.ReferrerRewarded]: 'Validé',
        [ReferralDisplayedStatus.MaxReferrerRewardsReached]: 'Validé',
      },
    },
    onYear: 'En {0}',
    pendingReferrals: 'Parrainages en cours',
    promotionalOffer: 'Offre promotionnelle',
    received: '{0} reçu',
    referredOn: 'Parrainé·e le {0}',
    registeredOn: 'Inscrit·e le {0}',
    shouldMakeATransaction: 'Doit effectuer une transaction',
    title: 'Parrainages',
  },
} as const);

export default locales;
